import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { I18N, GlobalContext } from 'commons';
import FieldErrorMessage from 'components/forms/FieldErrorMessage';

const Header = ({ isShowAddressVerifyTip, values, addressMandatory }) => {
  const {
    organization: { addressSetting: { mandatory = false } = {} },
  } = useContext(GlobalContext);

  return (
    <div className="pb-2">
      <h3
        className="h3-gray mt-5 pb-0"
      >
        <I18N>new.registration.signup.create.account.label.locationInformation</I18N>
      </h3>
      {isShowAddressVerifyTip && (
        <FieldErrorMessage id="verifyLocationErrorAlert" aria-hidden="true">
          <I18N>{(!addressMandatory && (!values.street || !values.locationName) && !(values.street && values.locationName))?
          'ssp.map.verify.your.location.errormsg.required':
          'ssp.map.verify.your.location.errormsg'}</I18N>
        </FieldErrorMessage>
      )}
      <span className="form-text" id="locationHelp">
        <I18N>new.registration.signup.create.account.location.help</I18N>
      </span>
    </div>
  );
};

Header.propTypes = {
  isShowAddressVerifyTip: PropTypes.bool.isRequired
};

export default Header;
